export const Divider = () => <div className="w-full h-0 border-t-[1px] border-sec10" />
